/**
 * R5BalanceBand
 * -----------------------------------------------------------
 * Token balance + recent activity strip for the Tokens page.
 *
 * Props:
 *   balance:  number | string
 *   label:    text under balance (default "Tokens\naboard")
 *   activity: [{ when, what, delta, sign?: 'plus' | 'minus' }]
 *   onLedgerClick: () => void  (or pass `ledgerHref` for an <a>)
 *   ledgerLabel: string (default "View Full Ledger →")
 */
import React from 'react';

export function R5BalanceBand({
  balance,
  label = 'Tokens\naboard',
  activity = [],
  onLedgerClick,
  ledgerHref,
  ledgerLabel = 'View Full Ledger →',
  className = '',
  ...rest
}) {
  const cls = ['r5-balance-band', className].filter(Boolean).join(' ');

  const ledger = ledgerHref ? (
    <a className="r5-balance-band__ledger" href={ledgerHref}>
      {ledgerLabel}
    </a>
  ) : onLedgerClick ? (
    <button
      type="button"
      className="r5-balance-band__ledger"
      onClick={onLedgerClick}
    >
      {ledgerLabel}
    </button>
  ) : null;

  return (
    <section className={cls} aria-label="Token balance" {...rest}>
      <div className="r5-balance-band__balance">
        <span className="r5-balance-band__num">{balance}</span>
        <span className="r5-balance-band__lbl" style={{ whiteSpace: 'pre-line' }}>
          {label}
        </span>
      </div>
      <div className="r5-balance-band__activity">
        {activity.map((item, i) => {
          const sign =
            item.sign ||
            (typeof item.delta === 'string' && item.delta.trim().startsWith('-')
              ? 'minus'
              : 'plus');
          return (
            <div key={i} className="r5-balance-band__item">
              {item.when && <span className="r5-balance-band__when">{item.when}</span>}
              {item.what && <span className="r5-balance-band__what">{item.what}</span>}
              {item.delta !== undefined && (
                <span
                  className={`r5-balance-band__delta r5-balance-band__delta--${sign}`}
                >
                  {item.delta}
                </span>
              )}
            </div>
          );
        })}
        {ledger}
      </div>
    </section>
  );
}

export default R5BalanceBand;
